import styled, { css } from 'styled-components';
import { colors, media } from '@prisjakt/ui-base';

export const StockStatusWrapper = styled.div`
  width: 100%;
  flex: 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  ${props =>
    props.toneDown &&
    css`
      svg path {
        fill: ${colors.lightGray2} !important;
      }
    `}
`;

export const HideOnMobile = styled.div`
  ${media.smallOnly`display: none;`}
`;

export const HideOnDesktop = styled.div`
  ${media.mediumUp`display: none;`}
`;

const hidePriceNoticeText = `
  .pj-ui-price-notice {
    margin-right: 0.5rem;
    @media screen and (max-width: 374px) {
      margin-right: 2px;
    }
  }
  .pj-ui-price-notice--text {
    display: none;
  }
`;

export const PriceNoticeWrapper = styled.div`
  ${props =>
    props.hideText &&
    css`
      ${hidePriceNoticeText}
    `}
`;
